import Axios from 'axios'

const PLATFORM_API_URI = process.env.https://api.integration.app

export default function usePlatformApi() {
  return {
    apiClient: getClient(),
    apiFetcher: fetcher,
    prodFetcher,
    apiBinaryFetcher: binaryFetcher,
    getToken,
    setToken,
    unsetToken,
  }
}

async function fetcher(url: string): Promise<any> {
  const response = await getClient().get(url, {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  })
  return response.data
}

async function prodFetcher(url: string): Promise<any> {
  const response = await getClient().get(url, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('prodToken')}`,
    },
  })
  return response.data
}

async function binaryFetcher(url: string): Promise<any> {
  const response = await getClient().get(url, {
    responseType: 'arraybuffer',
  })
  return response.data
}

function getClient() {
  const token = getToken()
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: token ? `Bearer ${getToken()}` : token,
  }

  return Axios.create({
    baseURL: PLATFORM_API_URI,
    headers,
  })
}

export function getToken() {
  if (typeof window !== 'undefined') {
    return localStorage.getItem('jwt')
  }
  return null
}

function setToken(token: string) {
  if (typeof window !== 'undefined') {
    localStorage.setItem('jwt', token)
  }
}

function unsetToken() {
  if (typeof window !== 'undefined') {
    localStorage.removeItem('jwt')
  }
}
